module.exports = __webpack_public_path__ + "img/list.2585a8c6.svg";